import { PageContainer } from '@ant-design/pro-components'
import { createFileRoute } from '@tanstack/react-router'
import { financeSearchSchema, GroupLedger, type FinanceListSearch } from '@/features/bill/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

const listQuery = createListQueryPersistence(
  'super-mega:finance:groups:list-query',
  financeSearchSchema.omit({ month: true })
)

export const Route = createFileRoute('/_authenticated/finance/groups')({
  beforeLoad: listQuery.restore,
  validateSearch: listQuery.validateSearch,
  component: GroupsPage
})

function GroupsPage() {
  const { currentSession } = Route.useRouteContext()
  const navigate = Route.useNavigate()
  const { search } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate
  })
  const canManage =
    currentSession.isSuperAdmin ||
    currentSession.permissions.some((permission) => permission.startsWith('bill.') && !permission.endsWith('.read'))
  const setSearch = (next: FinanceListSearch) => {
    void navigate({ search: next })
  }
  return (
    <PageContainer
      title="收款账单组"
      content="按客户与主体核对账单，编辑、出单并追溯历史快照。"
      breadcrumbRender={false}
    >
      <GroupLedger search={search} setSearch={setSearch} canManage={canManage} />
    </PageContainer>
  )
}
